import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export function ProtectedRoute({ children, roles }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-pulse text-muted-foreground">Loading ACCP…</div>
      </div>
    );
  }
  if (user === false) {
    // Preserve the route the user was trying to reach so Login can bounce
    // them back post-auth. Skip capturing "/" — no value adding `?next=/`.
    const current = location.pathname + location.search;
    const next = current && current !== "/" ? `?next=${encodeURIComponent(current)}` : "";
    return <Navigate to={`/login${next}`} replace />;
  }
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}
